import { colors } from '../../Colors/colors'

export const automationWorkflowsTheme = {
   light: {
      common: {
         accessDeniedDescriptionColor: 'text-gray-600',
         accessDeniedTitleColor: 'text-gray-900',
         addButtonPlusIconWhiteColor: colors['base-white'],
         addButtonPlusIconPrimaryColor: colors['primary-600'],
         clickableURLTextColor: 'text-primary-600',
         defaultDividerColor: 'bg-gray-300'
      },
      filters: {
         searchIconColor: colors['gray-500'],
         chevronDownIconColor: colors['gray-500'],
         checkIconColor: colors['primary-600'],
         filterHeaderBgColor: 'bg-gray-50',
         outlineDotsVerticalColor: colors['gray-500'],
         filterTitleColor: 'text-gray-800',
         filterBottomBorderColor: 'text-gray-300',
         filterCardBgColor: 'bg-base-white',
         filterCardBorderColor: 'border-gray-300',
         plusIconColor: colors['primary-600'],
         plusIconDisabledColor: colors['gray-400'],
         disabledPlusIconColor: colors['gray-300'],
         pickerTextColor: 'text-gray-900',
         horizontalLineColor: 'border-gray-300',
         arithmeticOperator: {
            operatorTextColor: 'text-gray-900',
            background: 'bg-base-white',
            disabledBackground: 'bg-gray-50',
            borderColor: 'border-gray-300 ',
            plusIconFillColor: colors['gray-500'],
            minusIconFillColor: colors['gray-500'],
            playUpIconFillColor: colors['gray-400'],
            playDownIconFillColor: colors['gray-300']
         },
         relationCard: {
            borderColor: 'border-gray-300',
            relationLabelColors: 'text-gray-500',
            relationValueColor: 'text-gray-800',
            relationSectionDividerColor: 'border-t-gray-200'
         },
         conditionOperator: {
            color: 'text-primary-700',
            bgColor: 'bg-primary-50',
            horizontalLineColor: 'border-gray-300 bg-gray-200'
         },
         menu: {
            actionHoverBg: 'hover:bg-gray-50'
         },
         leadStageField: {
            customOptionHoverBgColor: 'hover:bg-gray-50',
            focusBgColor: 'bg-gray-50',
            selectedBgColor: 'bg-gray-50',
            customOptionTextColor: 'text-gray-900',
            customBadgeTextColor: 'text-gray-700',
            checkIconColor: colors['primary-600'],
            badgeBorderColor: 'border-gray-300',
            badgeCloseIconColor: colors['gray-400']
         },
         execLogsStatusField: {
            customOptionHoverBgColor: 'hover:bg-gray-50',
            focusBgColor: 'bg-gray-50',
            selectedBgColor: 'bg-gray-50',
            checkIconColor: colors['primary-600']
         },
         relativeFilters: {
            arithmeticOperator: {
               disabledBGColor: 'bg-gray-50',
               disabledTextColor: 'text-gray-500',
               labelTextColor: 'text-gray-700',
               operatorArrowActiveIconColor: colors['gray-400'],
               operatorArrowDisabledIconColor: colors['gray-300'],
               operatorIconColor: colors['gray-900'],
               operatorTextColor: 'text-gray-900'
            }
         },
         filterSetCount: {
            borderColor: 'border-gray-300',
            labelColor: 'text-gray-500',
            valueColor: 'text-gray-900',
            userIconColor: colors['primary-600'],
            userIconSecondaryColor: colors['gray-600']
         },
         bgColor: 'bg-base-white'
      },
      basicWorkflowDetails: {
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-600 '
      },
      closeIconColor: colors['gray-500'],
      executionLogs: {
         activeSidePaneBgColor: 'bg-gray-50',
         headerBorderColor: 'border-gray-300',
         headerTitleColor: 'text-gray-900',
         refreshIconColor: colors['gray-700']
      },
      triggerNodeSelection: {
         title: {
            color: 'text-gray-900'
         },
         description: {
            color: 'text-gray-600'
         },
         triggerTypeActiveLabelTextColor: 'text-gray-500',
         triggerTypeValueTextColor: 'text-gray-900',
         verticalLineBgColor: 'bg-gray-300',
         triggerTypeLabelTextColor: 'text-gray-700',
         pickerSelectedItemDefaultColor: colors['base-white']
      },

      triggerNode: {
         borderColor: 'border-gray-300',
         iconColor: colors['gray-500'],
         selected: {
            borderColor: 'border-primary-600',
            iconColor: colors['primary-600']
         },
         titleColor: 'text-gray-700',
         descriptionColor: 'text-gray-600',
         userIconColor: colors['primary-600'],
         gitBranchIconColor: colors['gray-400'],
         plusIconColor: colors['gray-400'],
         headerTextColor: 'text-gray-900',
         selectedCardOutlineColor: 'outline-primary-600',
         workflowSidePaneLabelTextColor: 'text-gray-500',
         workflowSidePaneValueTextColor: 'text-gray-800',
         backIconColor: colors['primary-600'],
         checkSquareIconColor: colors['primary-600'],
         useIconColor: colors['primary-600'],
         activityIconColor: colors['primary-600'],
         optionsHRLineBgColor: 'bg-gray-200'
      },
      actionNode: {
         lightingIconColor: colors['primary-600'],
         gitBranchIconColor: colors['gray-400'],
         plusIconColor: colors['gray-400'],
         deleteButtonText: 'text-error-600'
      },
      conditionNode: {
         trueCaseGitBranchIconColor: colors['green-500'],
         plusIconColor: colors['gray-400'],
         falseCaseGitBranchIconColor: colors['orange-dark-600'],
         trueCasePlusSquareIconColor: colors['success-600'],
         falseCasePlusSquareIconColor: colors['error-600'],
         deleteButtonText: 'text-error-600',
         headerTitle: 'text-gray-900'
      },
      node: {
         deleteNodeTextColor: 'text-error-600'
      },
      actions: {
         color: colors['primary-600'],
         actionNodeHeaderTextColor: 'text-gray-900',
         hrLineColor: 'text-gray-300',
         headerCloseIcon: colors['gray-500'],
         actionPaneBgColor: 'bg-base-white',
         calenderIconColor: colors['gray-500'],
         timeIconColor: colors['gray-500'],
         deleteIconColor: colors['error-700'],
         valueSourceTextColor: 'text-gray-900',
         backIconColor: colors['gray-500']
      },
      automationWorkflowCard: {
         titleColor: 'text-gray-900',
         lastUpdatedAtTextColor: 'text-gray-600',
         publishedBgColor: 'bg-gray-100',
         publishedTextColor: 'text-gray-700',
         activityNameTextColor: 'text-gray-600',
         activityTypeTextColor: 'text-gray-700',
         createdAtTextColor: 'text-gray-600',
         featuredActivityIconFillColor: colors['primary-600'],
         featuredActivityIconOuterBgColor: colors['primary-50'],
         featuredActivityIconInnerBgColor: colors['primary-100'],
         featuredRocketTwoIconInnerBgColor: colors['warning-100'],
         featuredRocketTwoIconOuterBgColor: colors['warning-50'],
         featuredRocketTwoIconFillColor: colors['warning-600'],
         calendarCheckTwoIconFillColor: colors['gray-500'],
         featuredUserIconFillColor: colors['primary-600'],
         featuredUserIconOuterBgColor: colors['blue-50'],
         featuredUserIconInnerBgColor: colors['blue-100'],
         featuredCheckSquareIconFillColor: colors['blue-600'],
         featuredCheckSquareIconInnerBgColor: colors['blue-100'],
         featuredCheckSquareIconOuterBgColor: colors['blue-50'],
         playCircleIconColor: colors['success-600'],
         pauseCircleIconColor: colors['warning-600'],
         stopCircleIconColor: colors['gray-600'],
         deleteAWTextColor: 'text-error-600',
         cardBgColor: 'bg-base-white',
         cardHoverBorderColor: 'border-gray-300'
      },
      automationWorkFlowList: {
         listBgColor: 'bg-gray-100'
      },
      automationWorkFlowHeader: {
         WorkFlowHeader: 'bg-base-white border-gray-300',
         HeaderNameColor: 'text-gray-900',
         WorkFlowHeaderContainerColor: 'text-gray-600',
         disabledIconColor: colors['gray-300'],
         enabledIconColor: colors['gray-600'],
         tooltipBgColor: 'bg-gray-900',
         versionToggle: {
            borderColor: 'border-gray-100',
            backgroundColor: 'bg-gray-100',
            color: 'text-gray-500',
            selected: {
               bgColor: 'bg-base-white',
               color: 'text-gray-700'
            },
            horizontalLineColor: 'border-gray-300'
         }
      },
      aWDetailedViewHeader: {
         bgColor: 'bg-base-white',
         headerTitleColor: 'text-gray-900',
         backButtonColor: 'text-primary-600',
         publishButtonColor: 'text-gray-700',
         badgeChevronActiveColor: colors['success-600'],
         badgeChevronInActiveColor: colors['gray-600'],
         backIconColor: colors['gray-700'],
         statusActiveTextColor: 'text-success-700',
         statusInactiveTextColor: 'text-gray-700'
      },
      aWCardMoreActions: {
         actionItemHoverColor: 'hover:bg-gray-50',
         actionItemTextColor: 'text-gray-700'
      },
      awExecutionLogs: {
         awNameTextColor: 'text-gray-900',
         borderColor: 'border-gray-300',
         countLabelColor: 'text-gray-600',
         countValueColor: 'text-gray-700',
         executionIconColor: colors['gray-500'],
         executionLogsContainerBgColor: 'bg-gray-100',
         headerNameColor: 'text-gray-600',
         textColor: 'text-gray-600',
         userIconFillColor: colors['base-white'],
         userIconStrokeColor: colors['gray-500'],
         verticalLineColor: 'border-gray-300',
         backIconColor: colors['gray-700']
      },

      awExecutionLogsSidePane: {
         filterTextColor: 'text-gray-900',
         borderColor: 'border-gray-300'
      },

      nodes: {
         trueEdgeTypeNodeBorderColor: 'border-success-400',
         falseEdgeTypeNodeBorderColor: 'border-error-400',
         defaultEdgeTypeNodeBorderColor: 'border-gray-300',
         labelTextColor: 'text-gray-400',
         textColor: 'text-gray-800',
         statusDotColor: 'bg-orange-500',
         defaultNodeColor: 'border-gray-300',
         nodeSuccessColor: 'border-success-300',
         nodeFailureColor: 'border-error-300',
         nodeInprogressColor: 'border-primary-300'
      },
      customControl: {
         plusIconColor: colors['gray-500'],
         minusIconColor: colors['gray-500'],
         percentageTextColor: 'text-gray-700',
         percentageLeftAndRightBorderColor: 'border-gray-300',
         customControllerBgColor: 'bg-base-white',
         zoomButtonHoverColor: 'hover:bg-base-white'
      },
      partialNodes: {
         viewTextColor: 'text-primary-600',
         IncompletePartialNodesTextColor: 'text-gray-700',
         partialNodesBorderColor: 'border-gray-300',
         partialNodesBgColor: 'bg-base-white',
         actionNodeIconFillColor: colors['primary-600'],
         conditionNodeIconFillColor: colors['primary-600']
      },
      updateNodeCreateTask: {
         startDateAndTimeHeading: 'text-gray-900',
         startDateAndTimeBorderColor: 'border-gray-300'
      },
      childNodesExistWarningModal: {
         titleTextColor: 'text-gray-900',
         descriptionTextColor: 'text-gray-600'
      },
      workFlowSummary: {
         workflowSummaryTextColor: 'text-gray-900',
         workFlowSummaryDescriptionTextColor: 'text-gray-600',
         workflowSummaryKeyTextColor: 'text-gray-500',
         workflowSummaryValueTextColor: 'text-gray-800',
         checkSquareIconColor: colors['primary-600'],
         useIconColor: colors['primary-600'],
         activityIconColor: colors['primary-600']
      },
      automationWorkflowNotFound: {
         titleTextColor: 'text-gray-900',
         description: 'text-gray-600',
         notFoundBgColor: 'bg-gray-100'
      },
      updateLeadStageNodeSidePane: {
         customOptionHoverBgColor: 'hover:bg-gray-50',
         focusBgColor: 'bg-gray-50',
         selectedBgColor: 'bg-gray-50',
         customOptionTextColor: 'text-gray-900',
         checkIconColor: colors['primary-600'],
         pipelinesTextColor: 'text-gray-700',
         defaultBGColor: 'bg-base-white',
         defaultBorderColor: 'border-gray-300',
         lineBgColor: 'bg-gray-300'
      },
      automationWorkflowLoadingView: {
         flowLoadingViewBgColor: 'bg-gray-100'
      },
      scheduleAW: {
         sidePane: {
            headerTitle: 'text-gray-900',
            closeIconColor: colors['gray-500'],
            chevronIconColor: colors['gray-500'],
            headerBorderColor: 'border-gray-300',
            triggerTypeLabelTextColor: 'text-gray-700',
            triggerTypeTextColor: 'text-gray-900',
            hrLineBgColor: 'border-gray-300'
         }
      },
      segmentAction: {
         segmentCollapsibleCard: {
            chevronDownIconColor: colors['gray-500'],
            horizontalLineColor: 'border-gray-300',
            cardBorder: 'border-gray-300',
            cardBackgroundColor: 'bg-base-white',
            headerTitle: 'text-gray-800'
         }
      },
      horizontalTabs: {
         bgColor: 'bg-gray-50',
         borderColor: 'border-gray-100',
         selectedTabTextColor: 'text-gray-700',
         tabTextColor: 'text-gray-500'
      },
      nodeResultCard: {
         cardBorderColor: 'border-gray-300',
         cardBGColor: 'bg-white',
         badgeSuccessBorderColor: 'border-green-600',
         badgeSuccessBGColor: 'bg-green-50',
         badgeFailureBorderColor: 'border-pink-600',
         badgeFailureBGColor: 'bg-pink-50',
         evaluatedToTextColor: 'text-gray-500'
      },
      webHookResultCard: {
         borderColor: 'border-gray-300',
         cardBGColor: 'bg-white',
         headingTextColor: 'text-gray-700',
         successResultColor: 'text-green-600',
         failureResultColor: 'text-red-600',
         failedResultMessageColor: 'text-gray-800'
      },
      awExecutionLogReprocess: {
         headingTextColor: 'text-gray-900',
         descriptionTextColor: 'text-gray-600',
         closeIconColor: colors['gray-400']
      },
      nodeTypeCard: {
         nodeTypeCardBGColor: ' bg-white',
         nodeTypeCardBorderColor: 'border-gray-300',
         nodeTypeTextColor: 'text-gray-800',
         typeOfNodeTextColor: 'text-gray-500',
         dataFlow4IconFillColor: colors['primary-600'],
         Lightning1IconFillColor: colors['primary-600']
      },
      cardWithHeder: {
         cardBGColor: 'bg-white',
         cardBorderColor: 'border-gray-300',
         cardHeadingColor: 'text-gray-800'
      },
      pipelinesComboBox: {
         customOptionHoverBGColor: 'hover:bg-gray-50',
         tickIconColor: colors['primary-500'],
         optionTextColor: 'text-gray-500',
         labelColor: 'text-gray-700'
      },
      awsExecLogTableCell: {
         workflowLogIdColor: 'text-gray-600',
         leadNameColor: 'text-gray-600',
         workflowTitleColor: 'text-gray-600',
         lastExecutedAtColor: 'text-gray-600'
      },
      reprocessBulkAWsExecutionLog: {
         cardBorderColor: 'border-gray-300',
         cardBGColor: 'bg-white',
         checkBoxIconColor: colors['primary-600'],
         reprocessIconColor: colors['gray-600'],
         xIconColor: colors['gray-400'],
         verticalLineBGColor: 'bg-gray-300',
         selectedTextAndCountColor: 'text-primary-600',
         reprocessTextColor: 'text-gray-600'
      },
      workflowStatusIndication: {
         notExecutedTextColor: 'text-gray-600',
         executionSuccessTextColor: 'text-green-600',
         executionFailedTextColor: 'text-red-600'
      },
      filterLogCard: {
         chevronIconColor: colors['gray-500'],
         cardTitleColor: 'text-gray-800',
         bgColor: 'bg-gray-50',
         borderColor: 'border-gray-300',
         verticalLineColor: 'border-gray-300'
      },
      payloadFieldResponsesController: {
         bottomLineColor: 'bg-gray-200',
         fieldColor: 'text-gray-500',
         responseColor: 'text-gray-800',
         nodataTextColor: 'text-gray-800'
      },
      LatestPipelineItemFieldResponsesController: {
         bottomLineColor: 'bg-gray-200',
         fieldColor: 'text-gray-500',
         responseColor: 'text-gray-800',
         nodataTextColor: 'text-gray-800'
      },
      segmentActionsCard: {
         cardTitleColor: 'text-gray-800'
      },
      nodeNotExecuted: {
         textColor: 'text-warning-700',
         cardBGColor: 'bg-warning-25'
      },
      removeAssigneesTheme: {
         assigneeRemovedToTextColor: 'text-gray-600',
         assigneeTextColor: 'text-blue-600',
         cardBorderColor: 'border-gray-300',
         verticalLineColor: 'border-gray-600'
      },
      updateAssigneeTheme: {
         assigneeUpdatedToTextColor: 'text-gray-600',
         assigneeTextColor: 'text-blue-600',
         cardBorderColor: 'border-gray-300',
         hasUpdatedToTextColor: 'text-gray-600',
         labelColors: 'text-gray-700',
         notificationToggle: {
            description: 'text-gray-600',
            titleTextColor: 'text-gray-700',
            topBorderBGColor: 'bg-gray-300'
         },
         overrideAssigneeToggle: {
            description: 'text-gray-600',
            titleTextColor: 'text-gray-700'
         },
         updateAssigneeConfig: {
            titleTextColor: 'text-gray-500',
            horizontalLineColor: 'border-gray-200',
            assigneeNameTextColor: 'text-gray-800',
            fallbackAssigneeTextColor: 'text-gray-600',
            borderColor: 'border-gray-300'
         }
      },
      emitPipelineConfig: {
         headerBorderColor: 'border-gray-300',
         titleTextColor: 'text-gray-500',
         horizontalLineColor: 'border-gray-200',
         valueTextColor: 'text-gray-800'
      },
      createRelatedRecord: {
         relationDetails: {
            titleTextColor: 'text-gray-500',
            horizontalLineColor: 'border-gray-300',
            valueTextColor: 'text-gray-800',
            borderColor: 'border-gray-300',
            mainTitleColor: 'text-gray-700'
         },
         recordNameTextColor: 'text-gray-900',
         defaultTextColor: 'text-gray-600',
         highlightedTextColor: 'text-primary-600',
         dividerBgColor: 'bg-gray-300',
         assigneeFieldNameColor: 'text-gray-800',
         assigneeTextColor: 'text-primary-600'
      },
      relativeRecords: {
         sectionDivider: 'border-b-gray-300',
         labelColor: 'text-gray-900'
      },
      updateRelatedRecordCard: {
         cardBorderColor: 'border-gray-200',
         cardTitleColor: 'text-gray-900',
         cardDescriptionColor: 'text-gray-800',
         failedResultMessageColor: 'text-gray-800'
      },
      updateManagerAssignee: {
         cardBorderColor: 'border-gray-300',
         titleColor: 'text-gray-700',
         sectionDividerColor: 'border-t-gray-300 bg-gray-300'
      },
      updateManagerAssigneeLogs: {
         resultCard: {
            cardBorderColor: 'border-gray-300',
            managerFieldNameColor: 'text-gray-500',
            managerUserNameColor: 'text-gray-800',
            cardTitleColors: 'text-gray-700',
            resultSectionDividerColor: 'border-t-gray-300 bg-gray-300'
         },
         config: {
            cardBorderColor: 'border-gray-300',
            managerFieldNameColor: 'text-gray-500',
            managerUserNameColor: 'text-gray-800',
            cardTitleColors: 'text-gray-700',
            resultSectionDividerColor: 'border-t-gray-300 bg-gray-300',
            fieldsDividerStyle: 'border-t-gray-200 bg-gary-200'
         }
      },
      swiftSellWebHookNode: {
         sidePane: {
            defaultIconTextColor: 'text-gray-600',
            customFieldsSectionHeaderTextColor: 'text-gray-800',
            sectionDividerColors: 'bg-gray-300 border-t-gray-300'
         }
      },
      sendNotificationNode: {
         defaultHeaderTextColor: 'text-gray-800',
         defaultDescriptionTextColor: 'text-gray-700',
         defaultErrorTextColor: 'text-red-700',
         defaultBorderColor: 'border-gray-300',
         notifiedUsersTitle: 'text-gray-800',
         noNotifiedUsersTextColor: 'text-gray-500',
         notifiedUsersCardBorderColor: 'border-gray-300',
         sectionDividerColors: 'border-t-gray-300 bg-gray-300',
         assigneeFieldsMappingTextColor: 'text-primary-600',
         assigneeFieldNameColor: 'text-gray-600'
      },
      sendWhatsAppMessage: {
         defaultIconColor: colors['gray-600'],
         defaultHeaderTextColor: 'text-gray-800',
         defaultBorderColor: 'border-gray-300',
         defaultDescriptionTextColor: 'text-gray-700',
         fieldValesTextColor: 'text-primary-600',
         noFieldsTextColor: 'text-gray-500',
         dividerBgColor: 'bg-gray-300 border-t-gray-300'
      },
      requestPayment: {
         defaultBorderColor: 'border-gray-300',
         fieldLabelColor: 'text-gray-600',
         fieldValueColor: 'text-gray-800',
         sectionDividerColor: 'border-t-gray-200 bg-gray-200',
         logs: {
            titleTextColor: 'text-gray-500',
            horizontalLineColor: 'border-gray-300',
            valueTextColor: 'text-gray-800',
            borderColor: 'border-gray-300',
            mainTitleColor: 'text-gray-700'
         }
      },
      nodesCount: {
         default: {
            progressBarColor: 'bg-gray-300',
            progressColor: 'bg-gray-500',
            textColor: 'text-gray-500',
            dataFlowIconColor: colors['gray-500']
         },
         warning: {
            progressBarColor: 'bg-error-200',
            progressColor: 'bg-error-500',
            textColor: 'text-error-500',
            dataFlowIconColor: colors['error-500']
         }
      },
      createPaymentRequest: {
         defaultIconColor: colors['gray-600'],
         defaultHeaderTextColor: 'text-gray-800',
         defaultBorderColor: 'border-gray-300',
         defaultDescriptionTextColor: 'text-gray-700',
         fieldValesTextColor: 'text-primary-600',
         noFieldsTextColor: 'text-gray-500',
         dividerBgColor: 'bg-gray-300 border-t-gray-300',
         paymentRequestTitleColor: 'text-gray-800',
         chevronIconColor: colors['gray-500'],
         trashIconColor: colors['error-700'],
         paymentRequestBorderColor: 'border-gray-300',
         hrLineColor: 'bg-gray-300',
         dotsMoveIconFillColor: colors['gray-400']
      },
      actionField: {
         labelColor: 'text-gray-800'
      },
      addAnotherGof: {
         defaultBorderColor: 'border-gray-300',
         addAnotherGofButtonColor: 'text-primary-600',
         addAnotherGoFButtonDisabledTextColor: 'text-gray-300'
      },
      addAnotherGofExpandableCard: {
         defaultBGColor: 'bg-base-white',
         defaultBorderColor: 'border-gray-300',
         fieldsContainerBGColor: 'bg-white',
         collapseCardTextColor: 'text-gray-800',
         collapseCardDescriptionColor: 'text-gray-700',
         chevronIconColor: colors['gray-600']
      },
      addAnotherGofLog: {
         sectionDividerColor: 'border-t-gray-200 bg-gray-200',
         successResultColor: 'text-green-600',
         failureResultColor: 'text-red-600',
         failureMessageTextColor: 'text-gray-600',
         errorIconColor: colors['error-600'],
         titleColor: 'text-gray-800'
      },
      generateDocument: {
         defaultBorderColor: 'border-gray-300',
         sectionDividerColor: 'bg-gray-50',
         labelTextColor: 'text-gray-500',
         valueTextColor: 'text-gray-800',
         directValueTextColor: 'text-primary-600'
      },
      pipelineStagesValue: {
         sectionDividerColors: 'bg-gray-300 border-gray-300'
      }
   },

   dark: {}
}
